import Cross from "../../../assets/icons/Cross";
import { Activity } from "../../../types";

type Props = {
  currentMeetup: Activity | null;
  setIsCommentModalOpen: (value: boolean) => void;
};

export default function MeetupsCommentModal({
  currentMeetup,
  setIsCommentModalOpen,
}: Props) {
  const getComment = () => {
    if (!currentMeetup) return null;
    
    if (currentMeetup.additional_data?.comments && Array.isArray(currentMeetup.additional_data.comments)) {
      const rejectComment = currentMeetup.additional_data.comments.find(
        (comment: any) => comment.type === 'reject'
      );
      if (rejectComment?.content) {
        return rejectComment.content;
      }
    }
    
    if (currentMeetup.comment) return currentMeetup.comment;
    if (currentMeetup.reject_comment) return currentMeetup.reject_comment;
    if (currentMeetup.rejection_comment) return currentMeetup.rejection_comment;
    
    if (currentMeetup.additional_data) {
      if (currentMeetup.additional_data.reject_comment) return currentMeetup.additional_data.reject_comment;
      if (currentMeetup.additional_data.rejection_comment) return currentMeetup.additional_data.rejection_comment;
      if (currentMeetup.additional_data.comment) return currentMeetup.additional_data.comment;
    }
    
    return null;
  };

  const comment = getComment();

  return (
    <div 
      className="w-[540px] h-[50vh] p-8 rounded-xl bg-white text-black absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col z-50"
      onClick={(e) => e.stopPropagation()}
    >
      <div>
        <div
          onClick={() => setIsCommentModalOpen(false)}
          className="flex justify-end cursor-pointer"
        >
          <Cross additionalStyle="text-[#5F6B88]" />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto mt-4">
        <p className="text-xl font-medium mb-2">Причина отказа:</p>
        <p className="text-base text-gray-700 whitespace-pre-wrap">{comment || "Комментарий отсутствует"}</p>
      </div>
    </div>
  );
}
